"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addKeyTitle = addKeyTitle;
exports.createOptions = createOptions;
exports.tableRender = tableRender;
exports.InfiniteScrollDropDownTable = exports.default = exports.dropdownTableHOC = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _lodash = _interopRequireDefault(require("lodash"));

var _placements = _interopRequireDefault(require("rc-dropdown/lib/placements"));

var _CornerstoneSelect = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneSelect"));

var _helper = require("./helper");

var _infiniteScrollSelect = _interopRequireDefault(require("./infiniteScrollSelect"));

var _AdvancedDropdownMenu = _interopRequireDefault(require("./AdvancedDropdownMenu"));

require("./dropdown-table.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Option = _CornerstoneSelect.default.Option;
var InfiniteScrollSelect = (0, _infiniteScrollSelect.default)(_CornerstoneSelect.default);

function addKeyTitle(dataSource, keyField, titleField) {
  var disableAutoSort = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var result = dataSource.map(function (d) {
    return {
      key: _lodash.default.get(d, keyField),
      title: _lodash.default.get(d, titleField),
      record: d
    };
  });

  var compareValues = function compareValues(elemA, elemB) {
    if (!elemA || !elemB || !elemA.record || !elemB.record || !elemA.record[titleField] || !elemB.record[titleField] || typeof elemA.record[titleField] !== "string" || typeof elemB.record[titleField] !== "string") return 0;
    var comparison = elemA.record[titleField].localeCompare(elemB.record[titleField]);
    return comparison;
  };

  if (!disableAutoSort) {
    try {
      result = result.sort(compareValues);
    } catch (Err) {
      console.warn("Failed to execute Default Sort", Err);
    }
  }

  return result;
}

function createOptions(_ref) {
  var _ref$dataSource = _ref.dataSource,
      dataSource = _ref$dataSource === void 0 ? [] : _ref$dataSource,
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? [] : _ref$columns,
      _ref$getOptionProps = _ref.getOptionProps,
      getOptionProps = _ref$getOptionProps === void 0 ? function () {
    return {};
  } : _ref$getOptionProps;
  return dataSource.map(function (data, i) {
    var rest = getOptionProps(data.record) || {};

    var props = _objectSpread(_objectSpread({}, rest), {}, {
      key: data.key,
      value: data.key,
      title: data.title,
      children: columns.map(function (column) {
        var columnText = _lodash.default.get(data.record, column.dataIndex);

        var tdChild = column.render ? column.render(columnText, data.record, i) : columnText;
        var text = (0, _helper.renderedText)(data.record, column, i);
        var style = {
          width: column.width
        };
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "td",
          key: column.key,
          title: text,
          style: style
        }, tdChild);
      })
    });

    return /*#__PURE__*/_react.default.createElement(Option, props);
  });
}

var dropdownTableHOC = function dropdownTableHOC() {
  var SelectComp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _CornerstoneSelect.default;

  var DropdownTable = /*#__PURE__*/function (_React$Component) {
    _inherits(DropdownTable, _React$Component);

    var _super = _createSuper(DropdownTable);

    function DropdownTable() {
      var _this;

      _classCallCheck(this, DropdownTable);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "state", {
        columns: []
      });

      _defineProperty(_assertThisInitialized(_this), "isEqualToPreviousScrollLeft", function (scrollLeft) {
        var prevScrollLeft = _this.tableScrollLeft;
        _this.tableScrollLeft = scrollLeft;
        return prevScrollLeft === scrollLeft;
      });

      _defineProperty(_assertThisInitialized(_this), "handleResize", function () {
        var tableElement = _this.tableElement();

        if (tableElement) {
          _this.width = Number(tableElement.scrollLeft);

          _this.addExtraWidth();

          _this.calculateColumns();

          var extra = _this.dropdownTable.width > _this.width ? 10 : -10;
          tableElement.scroll(_this.width + extra, 0);
        }
      });

      _defineProperty(_assertThisInitialized(_this), "handleScroll", function (ev) {
        var tableElement = ev.currentTarget;
        var scrollLeft = Number(tableElement.scrollLeft); // check scrolling is vertical

        if (_this.isEqualToPreviousScrollLeft(scrollLeft)) {
          return _this.props.onPopupScroll ? _this.props.onPopupScroll(ev) : null;
        } // Adding width to tbody (ul) in horizonatal scrolling.


        var width = Number(tableElement.offsetWidth) + scrollLeft;

        var totalWidth = _this.columns().reduce(function (acc, col) {
          return col.width + acc;
        }, 20);

        width = totalWidth > width ? width : totalWidth;

        _this.addExtraWidth(tableElement, width);
      });

      _defineProperty(_assertThisInitialized(_this), "tableElement", function () {
        if (_this.table) {
          return _reactDom.default.findDOMNode(_this.table);
        }
      });

      _defineProperty(_assertThisInitialized(_this), "addExtraWidth", function () {
        var tableElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.tableElement();
        var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.width;

        if (!tableElement) {
          return;
        }

        _this.width = width;

        if (typeof width === "number" && width > 0) {
          var x = tableElement.children;

          for (var i = 0; i < x.length; i++) {
            x[i].style.width = width + "px";
          }
        }
      });

      _defineProperty(_assertThisInitialized(_this), "saveDropdownRef", function (el) {
        _this.dropdownRef = el;
      });

      _defineProperty(_assertThisInitialized(_this), "calculateColumns", function () {
        var _this$props = _this.props,
            columns = _this$props.columns,
            _this$props$dataSourc = _this$props.dataSource,
            dataSource = _this$props$dataSourc === void 0 ? [] : _this$props$dataSourc,
            dropdownMatchSelectWidth = _this$props.dropdownMatchSelectWidth;
        var minWidth, maxwidth;

        if (dropdownMatchSelectWidth) {
          minWidth = typeof dropdownMatchSelectWidth === "number" ? dropdownMatchSelectWidth : _this.dropdownTable.offsetWidth;
          maxwidth = minWidth;
        } else {
          minWidth = _this.dropdownTable.offsetWidth;
          maxwidth = window.innerWidth;
        }

        var nextColumns = addAutoWidthToColumns(columns, dataSource.map(function (d) {
          return d.record;
        }), minWidth, maxwidth);
        return _this.setState({
          columns: nextColumns
        });
      });

      _defineProperty(_assertThisInitialized(_this), "columns", function () {
        var columns = _this.props.columns;

        if (!columns.find(function (col) {
          return typeof col.width !== "number";
        })) {
          // All columns have width.
          return columns;
        }

        return columns.map(function (column) {
          var col = _this.state.columns.find(function (c) {
            return column.key === c.key;
          });

          var width = col ? col.width : getWidth(column);
          return _objectSpread(_objectSpread({}, column), {}, {
            width: width
          });
        });
      });

      _defineProperty(_assertThisInitialized(_this), "renderWrapper", function (innerMenu) {
        var _this$props2 = _this.props,
            columns = _this$props2.columns,
            wrapperRender = _this$props2.wrapperRender;

        var wrapper = /*#__PURE__*/_react.default.createElement("div", {
          id: "dropdownTable",
          ref: function ref(_ref2) {
            return _this.table = _ref2;
          },
          className: "table",
          onScroll: _this.handleScroll
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "thead"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "tr"
        }, _this.columns().map(function (column) {
          var style = {
            width: column.width
          };
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "th",
            key: column.key,
            title: column.title,
            style: style
          }, column.title);
        }).concat( /*#__PURE__*/_react.default.createElement("div", {
          className: "th",
          key: "filler"
        })))), innerMenu);

        return wrapperRender ? wrapperRender(wrapper) : wrapper;
      });

      _defineProperty(_assertThisInitialized(_this), "dropdownRender", function (menu) {
        var dropdownRender = _this.props.dropdownRender;

        var advancedDropdownMenu = /*#__PURE__*/_react.default.createElement(_AdvancedDropdownMenu.default, _extends({
          ref: menu.ref
        }, menu.props, {
          wrapper: _this.renderWrapper
        }));

        return dropdownRender ? dropdownRender(advancedDropdownMenu, menu) : advancedDropdownMenu;
      });

      return _this;
    }

    _createClass(DropdownTable, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.dropdownTable = _reactDom.default.findDOMNode(this);
        this.calculateColumns();
        window.addEventListener("resize", this.handleResize);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        window.addEventListener("resize", this.handleResize);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        // Typical usage (don't forget to compare props):
        if (!_lodash.default.isEqual(this.props.dataSource, prevProps.dataSource) || !_lodash.default.isEqual(this.props.columns, prevProps.columns)) {
          this.addExtraWidth();
          this.calculateColumns();
        }
      }
    }, {
      key: "getDefaultPlacement",
      value: function getDefaultPlacement() {
        return "bottomLeft";
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props3 = this.props,
            forwardedRef = _this$props3.forwardedRef,
            _this$props3$dataSour = _this$props3.dataSource,
            dataSource = _this$props3$dataSour === void 0 ? [] : _this$props3$dataSour,
            columns = _this$props3.columns,
            getOptionProps = _this$props3.getOptionProps,
            _this$props3$optionLa = _this$props3.optionLabelProp,
            optionLabelProp = _this$props3$optionLa === void 0 ? "title" : _this$props3$optionLa,
            _this$props3$optionFi = _this$props3.optionFilterProp,
            optionFilterProp = _this$props3$optionFi === void 0 ? "title" : _this$props3$optionFi,
            _this$props3$dropdown = _this$props3.dropdownClassName,
            dropdownClassName = _this$props3$dropdown === void 0 ? "" : _this$props3$dropdown,
            dropdownMatchSelectWidth = _this$props3.dropdownMatchSelectWidth,
            _this$props3$dropdown2 = _this$props3.dropdownPlacement,
            dropdownPlacement = _this$props3$dropdown2 === void 0 ? this.getDefaultPlacement() : _this$props3$dropdown2,
            dropdownAlign = _this$props3.dropdownAlign,
            filterOption = _this$props3.filterOption,
            children = _this$props3.children,
            _this$props3$allowCle = _this$props3.allowClear,
            allowClear = _this$props3$allowCle === void 0 ? true : _this$props3$allowCle,
            dropdownRender = _this$props3.dropdownRender,
            unSetMinWidth = _this$props3.unSetMinWidth,
            rest = _objectWithoutProperties(_this$props3, ["forwardedRef", "dataSource", "columns", "getOptionProps", "optionLabelProp", "optionFilterProp", "dropdownClassName", "dropdownMatchSelectWidth", "dropdownPlacement", "dropdownAlign", "filterOption", "children", "allowClear", "dropdownRender", "unSetMinWidth"]);

        var optionFilterFn = function optionFilterFn(input, option) {
          if (!input) return true; // if (option.key === ".$dropdown-table-header") {
          //   return true;
          // }

          if (typeof filterOption === "function") {
            return filterOption(input, option, dataSource.find(function (d) {
              return d.key === option.props.value;
            }).record);
          }

          return search(option.props[optionFilterProp], input);
        };

        var cols = this.columns();
        return /*#__PURE__*/_react.default.createElement(SelectComp, _extends({
          ref: forwardedRef,
          allowClear: allowClear,
          optionLabelProp: optionLabelProp,
          optionFilterProp: optionFilterProp,
          dropdownMatchSelectWidth: dropdownMatchSelectWidth,
          dropdownStyle: {
            width: null
          }
        }, rest, {
          dropdownClassName: "".concat(dropdownClassName, " cornerstone-dropdown-table ").concat(unSetMinWidth ? "unset-min-width" : ""),
          filterOption: filterOption ? optionFilterFn : false,
          dropdownAlign: dropdownAlign ? dropdownAlign : _placements.default[dropdownPlacement],
          dropdownRender: this.dropdownRender
        }), children ? children : createOptions({
          dataSource: dataSource,
          columns: cols,
          getOptionProps: getOptionProps
        }));
      }
    }]);

    return DropdownTable;
  }(_react.default.Component);

  _defineProperty(DropdownTable, "defaultProps", {
    dropdownMatchSelectWidth: false,
    unSetMinWidth: false,
    filterOption: true
  });

  return /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
    return /*#__PURE__*/_react.default.createElement(DropdownTable, _extends({}, props, {
      forwardedRef: ref
    }));
  });
};

exports.dropdownTableHOC = dropdownTableHOC;

var _default = dropdownTableHOC(_CornerstoneSelect.default);

exports.default = _default;
var InfiniteScrollDropDownTable = dropdownTableHOC(InfiniteScrollSelect);
exports.InfiniteScrollDropDownTable = InfiniteScrollDropDownTable;

function search() {
  var src = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var input = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  if (!src) return false;
  if (!input) return true;
  return src.toString().trim().toLowerCase().indexOf(input && input.toString().trim().toLowerCase()) === 0;
}

function getWidth(column) {
  if (typeof column.width === "number") {
    return column.width;
  } else {
    var title = column.title || column.name || column.dataIndex;
    return title ? title.length * 10 + 20 : 40;
  }
}

function addAutoWidthToColumns() {
  var columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var dataSource = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var minWidth = arguments.length > 2 ? arguments[2] : undefined;
  var maxWidth = arguments.length > 3 ? arguments[3] : undefined;
  var oneColumnMinWidth = minWidth / columns.length;
  var oneColumnMaxWidth = oneColumnMinWidth > 500 ? oneColumnMinWidth : 500;
  var renderedTable = tableRender(columns, dataSource);
  return columns.map(function (col, i) {
    if (typeof col.width === "number") return col;

    if (renderedTable.length) {
      var colsRendered = renderedTable.map(function (row) {
        return row[i];
      });
      var charLength = colsRendered.filter(function (colR) {
        return colR;
      }).filter(function (colR) {
        return typeof colR === "string" || typeof colR === "number";
      }).map(function (colR) {
        return colR.toString().length;
      }).reduce(function (a, b) {
        return Math.max(a, b);
      }, col.title.length);
      var w = charLength * 10 + 20;
      var width = w;

      if (w < oneColumnMinWidth) {
        width = oneColumnMinWidth;
      } else if (w > oneColumnMaxWidth) {
        width = oneColumnMaxWidth;
      }

      return _objectSpread(_objectSpread({}, col), {}, {
        width: width
      });
    }

    return _objectSpread(_objectSpread({}, col), {}, {
      width: getWidth(col)
    });
  });
}

function tableRender() {
  var columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var dataSource = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return dataSource.map(function (data, i) {
    return columns.map(function (col) {
      return (0, _helper.renderedText)(data, col, i);
    });
  });
}